import Icon from '../components/Icon.vue'

Icon.register({
  'user-cog': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M610.5 373.3l25.8 14.9c2.9 1.7 4.3 5.2 3.3 8.5-6.7 21.6-18.2 41.2-33.2 57.4-2.3 2.5-6.1 3.1-9 1.4l-25.8-14.9c-10.9 9.3-23.4 16.5-36.9 21.3v29.8c0 3.4-2.4 6.4-5.7 7.1-21.2 4.8-43.9 5-66.2 0-3.3-0.7-5.7-3.7-5.7-7.1v-29.8c-13.5-4.8-26-12-36.9-21.3l-25.8 14.9c-3 1.7-6.7 1.1-9-1.4-15-16.3-26.5-35.8-33.2-57.4-1-3.3 0.3-6.8 3.3-8.5l25.8-14.9c-2.6-14.1-2.6-28.5 0-42.6l-25.8-14.9c-2.9-1.7-4.3-5.2-3.3-8.5 6.7-21.6 18.2-41.2 33.2-57.4 2.3-2.5 6.1-3.1 9-1.4l25.8 14.9c10.9-9.3 23.4-16.5 36.9-21.3v-29.8c0-3.4 2.4-6.4 5.7-7.1 21.2-4.8 43.9-5 66.2 0 3.3 0.7 5.7 3.7 5.7 7.1v29.8c13.5 4.8 26 12 36.9 21.3l25.8-14.9c3-1.7 6.7-1.1 9 1.4 15 16.2 26.5 35.8 33.2 57.4 1 3.3-0.3 6.8-3.3 8.5l-25.8 14.9c2.6 14.1 2.6 28.5 0 42.6zM496 400.5c26.8 0 48.5-21.8 48.5-48.5s-21.8-48.5-48.5-48.5-48.5 21.8-48.5 48.5 21.7 48.5 48.5 48.5zM224 256c-70.7 0-128-57.3-128-128s57.3-128 128-128 128 57.3 128 128-57.3 128-128 128zM425.2 482.5v9.2c0 4.1 0.8 8 2 11.8-7.7 5.3-17.1 8.5-27.2 8.5h-352c-26.5 0-48-21.5-48-48v-41.6c0-74.2 60.2-134.4 134.4-134.4h16.7c22.3 10.2 46.9 16 72.9 16s50.7-5.8 72.9-16h16.7c3.9 0 7.6 0.9 11.4 1.2-1 2.9-2.3 5.8-3.2 8.7-5.5 17.7 1.9 36.5 17.9 45.7l7.9 4.6c-0.1 2.6-0.1 5.2 0 7.8l-7.9 4.6c-16 9.3-23.4 28-17.9 45.7 7.9 25.7 21.9 49.8 40.2 69.6 7.5 8 18 12.6 28.9 12.6 6.8 0 13.6-1.9 19.6-5.3l7.9-4.6c2.2 1.3 4.5 2.7 6.8 3.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-cog.js
// module id = 2060
// module chunks = 0